// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".intro-text-image-map .regions-map[data-v-6c3b117f]{display:none}@media (min-width:768px){.intro-text-image-map .regions-map[data-v-6c3b117f]{display:block}}.intro-text-image-map .regions-map .line-height-1-33[data-v-6c3b117f]{line-height:1.33}@media (min-width:992px){.show-map[data-v-6c3b117f],.show-map.sixty-forty[data-v-6c3b117f]{width:40%}}@media (min-width:992px){.fifty-fifty[data-v-6c3b117f],.show-map.fifty-fifty[data-v-6c3b117f]{width:50%}}", ""]);
// Exports
module.exports = exports;
